var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDesbloqueado2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "desbloqueado",
    transform: "translate(288 72)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-unlock",
    "data-name": "Icon feather-unlock",
    transform: "translate(-288 -71.995)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_125",
    "data-name": "Trazado 125",
    d: "M5,11H19a2,2,0,0,1,2,2v7a2,2,0,0,1-2,2H5a2,2,0,0,1-2-2V13a2,2,0,0,1,2-2Z",
    fill: "none",
    stroke: "#005691",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_126",
    "data-name": "Trazado 126",
    d: "M7,11V7a5,5,0,0,1,9.9-1",
    fill: "none",
    stroke: "#005691",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_82",
    "data-name": "Rect\\xE1ngulo 82",
    width: 24,
    height: 24,
    transform: "translate(-288 -72)",
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesbloqueado2);
export default __webpack_public_path__ + "static/media/desbloqueado2.5490db746e91eaae61df40b15f91130e.svg";
export { ForwardRef as ReactComponent };